import { formatTimeStr, generateUUID, timeFormat } from '@/utils/other';
import { pubsub, UPDATE_TODO_BONUS_EVENT } from '@/utils/pubsub';
import BaseListClass from './BaseListClass';
import ListClass from './ListClass';
import RequestApi from './RequestApiClass';

type ISearchModule = IModule.IRequest.ISearchModules;
type IModuleInfo = IModule.IResponse.IModuleInfo;
type ITodoInfo = ITodo.IResponse.ITodoInfo;

interface IGetModuleParams {
  pageindex: number;
  pagesize: number;
}

const defaultParams: IGetModuleParams = {
  pageindex: 1,
  pagesize: 100,
};

export default class ModuleListClass extends BaseListClass<IModuleInfo> {
  public $requestParams: ISearchModule = { ...defaultParams };
  public detailParams: ISearchModule = {
    returnComment: true,
    returnTodo: true,
  };
  constructor() {
    super({
      list: new ListClass<IModuleInfo>(),
      requestApi: new RequestApi('Module'),
    });
  }
  public requestCreateModuleFromTemplate<Q>(updateParams: Q): Promise<{id: string, msg: string}> {
    const id = generateUUID();
    return new Promise((reslove, reject) => {
      this.$requestApi
        .postData(this.$requestApi.createUrlById(id), updateParams)
        .then((res1) => {
          reslove({id, msg: res1.message});
        })
        .catch((err) => {
          reject(err.message);
        });
    });
  }
  public requestModuleSettles(
    module: IModuleInfo,
    todoIds: string[],
  ): Promise<string> {
    return new Promise((reslove, reject) => {
      this.requestApi.putData(
        this.requestApi.createUrl([module.id, 'settles']),
        todoIds,
        null,
      )
        .then((res) => {
          this.$moduleSettlement(module, todoIds);
          reslove(res.message);
        })
        .catch((error) => {
          reject(error.message);
        });
    });
  }

  public requestChangeItem<Q>(
    module: IModuleInfo,
    data: Q,
  ): Promise<string> {
    return new Promise((reslove, reject) => {
      this.requestApi.postData(
        this.requestApi.createUrlById(module.id),
        data,
      )
        .then((res) => {
          this.requestDetail({
            id: module.id,
          }).then((res2) => {
            reslove(res2);
          }).catch((err) => {
            reject(err);
          });
        })
        .catch((error) => {
          reject(error.message);
        });
    });
  }
  public $initRequestParams() {
    this.$requestParams = { ...defaultParams };
  }
  public convertData(modules: IModuleInfo[]): IModuleInfo[] {
    return modules.map((module) => ({
      ...module,
      due: formatTimeStr(module.due),
      createdOn: timeFormat(module.createdOn),
    }));
  }
  public $moduleSettlement(module: IModuleInfo, todoIds: string[]) {
    module.todos.forEach((todo) => {
      if (todoIds.includes(todo.id)) {
        todo.isBonus = true;
      }
    });
    this.list.updateItem({...module, status: 'Completed'});
    pubsub.publish(UPDATE_TODO_BONUS_EVENT, todoIds);
  }
  public createModule(): IModule.IRequest.IUpdateModuleParams {
    return {
      quotationId: '',
      title: '',
      due: '',
      manDay: 0,
      comment: '',
    };
  }
  public checkItem(module: IModuleInfo) {
    const result: boolean[] = [];
    ['id', 'requirementId', 'quotationId', 'projectId', 'status'].forEach((key) => {
      if (this.$requestParams[key as keyof ISearchModule]) {
        result.push(
          module[key as keyof IModuleInfo] === this.$requestParams[key as keyof ISearchModule],
        );
      }
    });
    if (this.$requestParams.title) {
      result.push(module.title.includes(this.$requestParams.title));
    }
    return result.every((value) => value);
  }
  public unshiftToTodos(module: IModuleInfo, todo: ITodoInfo) {
    if (todo.moduleId === module.id) {
      module.todos.unshift(todo);
    }
    this.list.updateItem({...module});
  }
  public deleteTodo(module: IModuleInfo, todo: ITodoInfo) {
    if (todo.moduleId === module.id) {
      const index = module.todos.findIndex((item) => item.id === todo.id);
      module.todos.splice(index, 1);
    }
    this.list.updateItem({...module});
  }
  public updateTodo(module: IModuleInfo, todo: ITodoInfo) {
    if (todo.moduleId === module.id) {
      for (const todoInfo of module.todos) {
        if (todoInfo.id === todo.id) {
          todoInfo.status = todo.status;
          todoInfo.manDay = todo.manDay;
          break;
        }
      }
      this.list.updateItem({...module});
    }
  }
}

export const moduleListInstance = new ModuleListClass();
